// extracted by mini-css-extract-plugin
export var filterIncDec = "_f2-0";
export var leftBorder = "_f2-1";
export var rightBorder = "_f2-2";
export var stringInput = "_f2-3";